
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16pt","height":"16pt","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.992 8.148c0-.652-.055-1.132-.172-1.628H8.16v2.957h4.496c-.09.738-.582 1.843-1.668 2.59l-.015.097 2.422 1.832.168.02c1.539-1.391 2.43-3.438 2.43-5.868","fill":"#4285f4"}}),_c('path',{attrs:{"d":"M8.16 15.945c2.203 0 4.05-.707 5.402-1.93l-2.574-1.949c-.691.47-1.613.797-2.828.797a4.897 4.897 0 01-4.64-3.312l-.098.008-2.52 1.902-.03.09c1.339 2.605 4.097 4.394 7.288 4.394","fill":"#34a853"}}),_c('path',{attrs:{"d":"M3.52 9.55a4.818 4.818 0 01-.274-1.577c0-.551.102-1.082.262-1.578l-.004-.106-2.55-1.934-.083.04A7.798 7.798 0 000 7.973a7.81 7.81 0 00.871 3.578l2.649-2","fill":"#fbbc05"}}),_c('path',{attrs:{"d":"M8.16 3.082c1.531 0 2.567.648 3.152 1.188l2.305-2.196C12.203.79 10.363 0 8.16 0 4.97 0 2.21 1.79.871 4.395l2.637 2A4.924 4.924 0 018.16 3.082","fill":"#eb4335"}})])
          )
        }
      }
    